export default __webpack_public_path__ + "990ca6d9e6af687994a313d1315ae057.png";